
import { Component, Vue, Prop } from 'vue-property-decorator'
import { handleFill } from '@/utils/util'
import { formatDate } from './../../index'

@Component
class ConfigLotteryQualification extends Vue {
  @Prop({ default: () => ({}) }) formData!: any

  handleFill = handleFill

  get statisticsTimeText() {
    const { statisticsStartTime = '', statisticsEndTime = '' } = this.formData
    return `${formatDate(statisticsStartTime)} - ${formatDate(
      statisticsEndTime
    )}`
  }
}
export default ConfigLotteryQualification
